export default {
  API_BASE_URL: 'https://mtu-api-uat.attrecto-dev.com/api',
  STORAGE_BASE_URL: 'https://mtu-api-uat.attrecto-dev.com',
};
